import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, BootstrapModalForm, Input } from "components/bootstrap";
import { IfPermitted } from "components/common";
import ObjectUtils from "util/ObjectUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const defaultConfig = {
  tor_enabled: false,
  spamhaus_enabled: false
};
const ThreatIntelPluginConfig = ({ config: initialConfig = defaultConfig, updateConfig }) => {
  const { t } = useTranslation("integrations");
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState(ObjectUtils.clone(initialConfig));
  const sendTelemetry = useSendTelemetry("threat-intel");
  const _updateConfigField = (field, value) => {
    const newConfig = {
      ...config,
      [field]: value
    };
    setConfig(newConfig);
  };
  const _onCheckboxClick = (e) => {
    _updateConfigField(e.target.name, e.target.checked);
  };
  const _openModal = () => {
    setShowModal(true);
  };
  const _closeModal = () => {
    setShowModal(false);
  };
  const _resetConfig = () => {
    setConfig(initialConfig);
    _closeModal();
  };
  const _saveConfig = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.THREATINTEL_CONFIGURATION_UPDATED, {
      app_pathname: "configurations"
    });
    updateConfig(config).then(() => {
      _closeModal();
    });
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", null, t("threat_intel_plugin_config.title")), /* @__PURE__ */ React.createElement("p", null, t("threat_intel_plugin_config.description")), /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, t("threat_intel_plugin_config.tor_exit_nodes_label")), /* @__PURE__ */ React.createElement("dd", null, config.tor_enabled === true ? t("threat_intel_plugin_config.enabled") : t("threat_intel_plugin_config.disabled")), /* @__PURE__ */ React.createElement("dt", null, t("threat_intel_plugin_config.spamhaus_label")), /* @__PURE__ */ React.createElement("dd", null, config.spamhaus_enabled === true ? t("threat_intel_plugin_config.enabled") : t("threat_intel_plugin_config.disabled"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: _openModal }, t("aws_plugin_configuration.edit_configuration"))), /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      title: t("threat_intel_plugin_config.modal_title"),
      onSubmitForm: _saveConfig,
      onCancel: _resetConfig,
      submitButtonText: t("aws_plugin_configuration.submit_configuration")
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "tor-checkbox",
        label: t("threat_intel_plugin_config.tor_checkbox_label"),
        help: t("threat_intel_plugin_config.tor_checkbox_help"),
        name: "tor_enabled",
        checked: config.tor_enabled,
        onChange: _onCheckboxClick
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "spamhaus-checkbox",
        label: t("threat_intel_plugin_config.spamhaus_checkbox_label"),
        help: t("threat_intel_plugin_config.spamhaus_checkbox_help"),
        name: "spamhaus_enabled",
        checked: config.spamhaus_enabled,
        onChange: _onCheckboxClick
      }
    ))
  ));
};
export default ThreatIntelPluginConfig;
